import React from "react";
import PropTypes from "prop-types";

const Footer = ({ entity, entityUrls, campaignName }) => {
  return (
    <footer className="entity navbar navbar-default">
      <div className="color-overlay">
        <div className="container">
          <div className="row text-center">
            {(entity.footlogo?.url || entity.footlogo) && (
              <p>
                <img
                  src={entity.footlogo.url || entity.footlogo}
                  alt={`${campaignName} Logo`}
                />
              </p>
            )}
            <p
              className="tagline"
              dangerouslySetInnerHTML={{ __html: entity.footer_tagline }}
            />
            {(entity.facebook_url ||
              entity.twitter_url ||
              entity.instagram_url ||
              entity.linkedin_url ||
              entity.snapchat_url) && (
              <>
                <div className="divider-social" />
                <h5 className="social-tagline">Connect With Us:</h5>
                <ul className="social-list">
                  {entity.facebook_url && (
                    <li>
                      <a
                        data-testid="t-Footer-visit-us-on-facebook"
                        href={entity.facebook_url}
                        aria-label="Visit us on Facebook"
                        className="footer-link"
                        target="_blank"
                        rel="noopener noreferrer">
                        <span className="fa-stack">
                          <i className="fa fa-circle fa-stack-2x footer-nav-link" />
                          <i className="fa fa-brands fa-facebook" />
                        </span>
                      </a>
                    </li>
                  )}
                  {entity.twitter_url && (
                    <li>
                      <a
                        data-testid="t-Footer-visit-us-on-twitter"
                        href={entity.twitter_url}
                        aria-label="Visit us on Twitter"
                        className="footer-link"
                        target="_blank"
                        rel="noopener noreferrer">
                        <span className="fa-stack">
                          <i className="fa fa-circle fa-stack-2x footer-nav-link" />
                          <i className="fa fa-brands fa-x-twitter" />
                        </span>
                      </a>
                    </li>
                  )}
                  {entity.instagram_url && (
                    <li>
                      <a
                        data-testid="t-Footer-visit-us-on-instagra"
                        href={entity.instagram_url}
                        aria-label="Visit us on Instagram"
                        className="footer-link"
                        target="_blank"
                        rel="noopener noreferrer">
                        <span className="fa-stack">
                          <i className="fa fa-circle fa-stack-2x footer-nav-link" />
                          <i className="fa fa-brands fa-instagram" />
                        </span>
                      </a>
                    </li>
                  )}
                  {entity.linkedin_url && (
                    <li>
                      <a
                        data-testid="t-Footer-visit-us-on-linkedin"
                        href={entity.linkedin_url}
                        aria-label="Visit us on LinkedIn"
                        className="footer-link"
                        target="_blank"
                        rel="noopener noreferrer">
                        <span className="fa-stack">
                          <i className="fa fa-circle fa-stack-2x footer-nav-link" />
                          <i className="fa fa-brands fa-linkedin" />
                        </span>
                      </a>
                    </li>
                  )}
                  {entity.youtube_url && (
                    <li>
                      <a
                        data-testid="t-Footer-visit-us-on-youtube"
                        href={entity.youtube_url}
                        aria-label="Visit us on YouTube"
                        className="footer-link"
                        target="_blank"
                        rel="noopener noreferrer">
                        <span className="fa-stack">
                          <i className="fa fa-circle fa-stack-2x footer-nav-link" />
                          <i className="fa fa-brands fa-youtube" />
                        </span>
                      </a>
                    </li>
                  )}
                  {entity.snapchat_url && (
                    <li>
                      <a
                        data-testid="t-Footer-visit-us-on-snapchat"
                        href={entity.snapchat_url}
                        aria-label="Visit us on Snapchat"
                        className="footer-link"
                        target="_blank"
                        rel="noopener noreferrer">
                        <span className="fa-stack">
                          <i className="fa fa-circle fa-stack-2x footer-nav-link" />
                          <i className="fa fa-brands fa-snapchat" />
                        </span>
                      </a>
                    </li>
                  )}
                </ul>
              </>
            )}
            <div className="divider-social" />
            {entityUrls
              .filter((eu) => eu.location.includes("footer"))
              .map((eu, index) => (
                <span key={index}>
                  {index !== 0 && <span className="footer-slash"> / </span>}
                  {eu.external ? (
                    <a
                      data-testid="t-Footer-a-7"
                      href={eu.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="footer-nav-link"
                      alt={eu.name}>
                      {eu.name}
                    </a>
                  ) : (
                    <a
                      data-testid="t-Footer-a-8"
                      href={eu.url}
                      className="footer-nav-link"
                      alt={eu.name}>
                      {eu.name}
                    </a>
                  )}
                </span>
              ))}

            {entity.copyright && (
              <p
                className="footer-copyright"
                dangerouslySetInnerHTML={{ __html: entity.copyright }}
              />
            )}
            <div className="powered-by-footer">
              <span>Powered by:</span>
              <a
                data-testid="t-Footer-a-9"
                href="https://gravyty.com/advance/"
                target="_blank"
                rel="noopener noreferrer">
                <img
                  src="https://gw-advance-prod-us-east-1.s3.amazonaws.com/grad_advance/gravyty_logo_white_32.png"
                  alt="Gravyty logo"
                  className="powered-by-logo"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  entity: PropTypes.object.isRequired,
  entityUrls: PropTypes.array.isRequired,
  campaignName: PropTypes.string.isRequired,
};

export default Footer;
